<template>
  <!-- modal -->
  <div class="dimed wrap">
    <div class="layer">
      <div class="layer__header">
        <div class="lyr-title">{{ $t('Modal.Barcode.msg1') }}</div>
        <div class="ft-point">
          {{ $t('Modal.Barcode.msg2') }}
        </div>
        <div class="lyr-txt">{{ $t('Modal.Barcode.msg3') }}</div>
      </div>
      <div class="layer__body">
        <img src="@/assets/images/user/img-info05.png" alt="" class="img-size" />
      </div>
      <div class="layer__button">
        <button class="btn btn--line btn--xlg btn-anim" @mouseup="closeBarcode()">{{ $t('Modal.Barcode.msg4') }}</button>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: 'barcode',
  data() {
    return {
      darkModeYn: this.$store.getters.getDarkModeYn,
    };
  },
  mounted() {},
  props: {},
  methods: {
    closeBarcode() {
      this.$emit('closeBarcode');
      this.$store.dispatch('startIdle');
    },
  },
  computed: {
    darkMode: function () {
      return this.$store.getters.getDarkModeYn;
    },
  },
  watch: {
    darkMode() {
      this.darkModeYn = this.darkModeYn ? false : true;

      this.$changeDarkMode(this.darkModeYn);
    },
  },
  updated() {
    this.$showButtonAnimation();
  },
};
</script>

<style src="@/assets/css/user/common.css" scoped></style>
<style src="@/assets/css/user/dark/common-dark.css" scoped></style>
<style scoped>
@media (-webkit-device-pixel-ratio: 1.25) {
  .ft-point {
    font-size: 1.2em !important;
  }
}
</style>
